export const themeOptionFactory = (theme) => ({
  assets: {
    bts: {
      mime: "image/png",
      url: "https://s3.venue.in.th/BTS_M_a827ee7f50.jpg",
      width: 1168,
      height: 335,
    },
    btsMap: {
      mime: "image/jpg",
      url: "https://s3.venue.in.th/bts_map_1dc9182de5.jpeg",
      width: 1190,
      height: 1612,
    },
    taxi: {
      mime: "img/png",
      url: "https://s3.venue.in.th/Taxi_M_b4350b73b0.jpg",
      width: 1168,
      height: 335,
    },
  },
  components: {
    EmTransportationPage: {
      styleOverrides: {
        root: {
          background: `
          linear-gradient(108deg, rgba(255, 255, 255, 0.90) 80.32%, rgba(255, 255, 255, 0.00) 158.97%, rgba(255, 255, 255, 0.00) 158.97%),
          url("https://s3.venue.in.th/transportation_bg_a72da7301a.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          borderRadius: "20px",
        },
        pageCardContent: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        },
        motionDiv: {
          height: "100%",
        },
        cardWrapper: {
          display: "flex",
          gap: theme.spacing(4.5),
          alignItems: "center",
          justifyContent: "center",
          "&>*": {
            width: "320px",
          },
        },
        qrCode: {
          " .AppQRCode-content": {
            width: 128,
            height: 128,
          },
        },
      },
    },
    EmBusTransportationPage: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
          borderRadius: "20px",
        },
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(4),
          padding: theme.spacing(3, 5.5),
        },
        pageTitle: {
          fontSize: "4rem",
          fontWeight: 700,
        },
        trafficTabs: {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        trafficTab: {
          fontSize: "1.5rem",
        },
        trafficTabPanel: {},
        trafficTabContainer: {
          flexGrow: 1,
        },
        button: {
          fontSize: "18px",
          //to prevent style overwrite from MUI
          "& .MuiButton-startIcon>*:nth-of-type(1)": {
            fontSize: "24px",
          },
          flex: "0 0 288px",
        },
        busCardWrapper: {
          display: "grid",
          gridTemplateColumns: "repeat(5, 215px)",
          gap: theme.spacing(2),
          gridTemplateRows: "repeat(3, 105px)",
          padding: theme.spacing(0, 1.75),
        },
        qrCodeWrapper: {
          marginTop: theme.spacing(4),
        },
        buttonWrapper: {
          marginTop: theme.spacing(3),
          justifyContent: "center",
        },
      },
    },
    TransportationCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          minHeight: "unset",
          borderRadius: "10px",
          "& .MuiCardContent-root": {
            transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
          },
          "&:hover": {
            "& .MuiCardContent-root": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        },
        cardMedia: {
          height: "400px",
        },
        cardIconWrapper: {
          "& .MuiSvgIcon-root": {
            width: "40px",
            height: "40px",
            color: theme.palette.common.white,
          },
        },
        cardContent: {
          height: "125px",
          width: "100%",
          gap: theme.spacing(2),
          padding: theme.spacing(2.5, 4),
          backgroundColor: theme.palette.secondary.dark,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        cardTitle: {
          fontSize: "20px",
          color: theme.palette.primary.contrastText,
          textAlign: "center",
          lineHeight: 1.45,
        },
        locationButton: {
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
          },
        },
      },
    },
    BusStopCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          padding: theme.spacing(1),
          borderRadius: "10px",
          backgroundColor: "#F1F1F1",
        },
        headerWrapper: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(2.5),
        },
        headerTitle: {
          fontSize: "1rem",
          fontWeight: 700,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        },
        contentWrapper: {
          marginTop: theme.spacing(2),
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
        },
        contentText: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        },
        iconWrapper: {
          display: "flex",
          color: theme.palette.primary.main,
          "& .MuiSvgIcon-root": {},
        },
      },
    },
    TransportationTabPanel: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4, 0),
        },
      },
    },
    EmTaxiTransportationPage: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
          borderRadius: "20px",
        },
        pageCardContent: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        },
        title: {
          fontSize: "4rem",
          textTransform: "uppercase",
          fontWeight: 700,
          width: "100%",
          padding: theme.spacing(5),
          marginBottom: theme.spacing(4),
        },
        contentWrapper: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(9),
        },
        cardMedia: {
          marginBottom: theme.spacing(4),
          width: 1168,
          height: 478,
          borderRadius: "10px",
        },
        button: {
          height: "64px",
          flex: "0 0 224px",
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
          },
        },
        buttonWrapper: {
          display: "flex",
          gap: theme.spacing(2),
        },
      },
    },
    EmBtsTransportationPage: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
          borderRadius: "20px",
        },
        pageCardContent: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        },
        title: {
          fontSize: "4rem",
          textTransform: "uppercase",
          fontWeight: 700,
          width: "100%",
          padding: theme.spacing(5),
          marginBottom: theme.spacing(4),
        },
        contentWrapper: {
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        },
        cardMedia: {
          marginBottom: theme.spacing(4),
          width: 1168,
          height: 335,
          borderRadius: "10px",
        },
        button: {
          height: "64px",
          flex: "0 0 224px",
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
          },
        },
        buttonWrapper: {
          marginTop: theme.spacing(3),
        },
        mapButton: {
          textDecoration: "underline",
          padding: 0,
          marginBottom: theme.spacing(4),
        },
      },
    },
    TransportationImageModal: {
      styleOverrides: {
        root: {
          width: "65vw", //  Page content width
          top: theme.spacing(15.75), // Top padding for content page (20px) + Header height (106px)
          left: theme.spacing(4.125), // Content page padding: 33px
          bottom: theme.spacing(2.5), // Bottom padding for content page: 20px
          "& .MuiBackdrop-root": {
            position: "absolute",
            borderRadius: "15px",
            "&:after": {
              position: "fixed",
              display: "flex",
              content: "''",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            },
          },
        },
        imageWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        image: {
          borderRadius: "20px",
          height: "778px",
          marginTop: theme.spacing(4),
        },
        closeButton: {
          padding: theme.spacing(0.5, 2),
          marginTop: theme.spacing(2),
          borderRadius: "9999px",
        },
      },
    },
  },
})
